import { get } from 'aws-amplify/api';

async function GetAllEquipment() {
    try {
      const url = 'https://k0uhot18c2.execute-api.us-east-1.amazonaws.com/staging/equipments'; // Adjusted URL for all data

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          // Add Authorization header if required
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Fetched Equipment Data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching equipment data:', error);
    }
  }

  export default GetAllEquipment;
